import { Flex, Stack, Text } from '@chakra-ui/react';
import type { ComponentType, SVGProps } from 'react';

export type ConnectFeature = {
  icon: ComponentType<SVGProps<SVGSVGElement>>;
  label: string;
};

/** The three points of a connection (mock-up: 30px tile, 13.5px label). */
export const ConnectFeatureList = ({ features }: { features: ConnectFeature[] }) => (
  <Stack as="ul" listStyleType="none" gap="12px" mt="22px" mb="4px" p={0}>
    {features.map(({ icon: Icon, label }) => (
      <Flex as="li" key={label} align="center" gap="12px">
        <Flex
          flex="none"
          w="30px"
          h="30px"
          borderRadius="8px"
          bg="softCream"
          align="center"
          justify="center"
        >
          <Icon width={16} height={16} color="var(--chakra-colors-nav-inactive)" aria-hidden />
        </Flex>
        <Text fontSize="13.5px" color="navInactive">
          {label}
        </Text>
      </Flex>
    ))}
  </Stack>
);
